module.exports = __webpack_public_path__ + "img/unsei-daikichi.fd4503b4.png";